'use client';

import dynamic from 'next/dynamic';
import React from 'react';

// Lazy load the Testimonial component (named export)
const LazyTestimonial = dynamic(
  () => import('./Testimonial').then((mod) => ({ default: mod.Testimonial })),
  {
    ssr: false, // Client-side only for consistency
    loading: () => (
      <div className="bg-white rounded-lg p-6 mb-6 border border-gray-200">
        <div className="animate-pulse">
          <div className="flex items-center mb-4">
            <div className="h-4 bg-gray-200 rounded w-24"></div>
          </div>
          <div className="space-y-2">
            <div className="h-3 bg-gray-100 rounded"></div>
            <div className="h-3 bg-gray-100 rounded w-5/6"></div>
            <div className="h-3 bg-gray-100 rounded w-4/6"></div>
          </div>
          <div className="mt-4 flex items-center space-x-2">
            <div className="h-4 bg-gray-200 rounded w-32"></div>
            <div className="h-4 bg-gray-200 rounded w-24"></div>
          </div>
        </div>
      </div>
    )
  }
);

// Wrapper with intersection observer for true lazy loading
export default function LazyTestimonialWrapper(props: any) {
  const [shouldLoad, setShouldLoad] = React.useState(false);
  const containerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      {
        // Load when component is 300px away from viewport (earlier for testimonials)
        rootMargin: '300px',
        threshold: 0
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef}>
      {shouldLoad ? (
        <LazyTestimonial {...props} />
      ) : (
        <div className="bg-white rounded-lg p-6 mb-6 border border-gray-200">
          <div className="text-gray-300 text-sm">
            <p>Testimonial loading...</p>
          </div>
        </div>
      )}
    </div>
  );
}